import styled from 'styled-components';

export default styled.div`
  display: grid;
  grid-gap: 20px 0;
  margin: 0px 0 15px;
`;
